module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAMAAABFjsb+AAAAAXNSR0IB2cksfwAAAFFQTFRFAAAATJ/XS5/ZS57ZSp7YS57ZTZ/ZSp7aSp/aTJ3ZSp3aSJ/XS57ZS57ZS57ZS57ZS57ZSp/ZS53YUJ/fTZ7bSp7YS57ZTJ/YS5/aS57ZS57aGwJGSgAAABt0Uk5TAECf78CwUJAwgGAg4M+g0P9/cBA/T99vj/C/vAb5HwAAAI5JREFUeJx1kEkSwyAMBAWWDQIHYlAW5/8PjcLigkP6wlTXACoBNJResLI2s6Gx2HI/qWRHgkfYb2FR8V7dIYhLZFPKWJxlIV93H8Up4XLeRP3kSneCpV1+wEAbDBgF4BxMGJnIh0n5iMPEnZilbMcas34xH28/lKgx3P7FgGp68ZQ1yXIQz7k3hz/u01i/3IMGbtIs+NMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temp/ico-drill.png
// module id = 753
// module chunks = 1